import { CircularProgress, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export function NewsFeedLoadingPageState() {
  return (
    <Stack spacing={4} flexGrow={1} justifyContent="center" alignItems="center">
      <CircularProgress />
      <Text>Loading news feed...</Text>
    </Stack>
  );
}
